import Repository from "./Repository";

const CREATE_CAMPAIGN_BANNER = "create";
const EDIT_CAMPAIGN_BANNER = "update";
const GET_ALL_CAMPAIGN_BANNER = "getall";
const DELETE_CAMPAIGN_BANNER = "delete";
// for campaign master routes
const GET_CAMPAIGN_MASTER = "getMaster";
const ADD_CAMPAIGN_MASTER = "addMaster";
const UPDATE_CAMPAIGN_MASTER = "updateMaster";

// for campaign partner routes
const GET_PARTNER = "getall";
const CREATE_PARTNER = "create";
const UPDATE_PARTNER = "update";
const DELETE_PARTNER = "delete";
// for campaign Home routes
const GET_CAMPAIGN_HOME = "getall";
const CREATE_CAMPAIGN_HOME = "create";
const UPDATE_CAMPAIGN_HOME = "update";
const DELETE_CAMPAIGN_HOME = "delete";
// for aboutcampaigns banner route
const GET_ABOUT_CAMPAIGN = "getall";
const CREATE_ABOUT_CAMPAIGN = "Add";
const UPDATE_ABOUT_CAMPAIGN = "update";
const DELETE_ABOUT_CAMPAIGN = "delete";
/// Campaigns references route
const GET_CAMPAIGN_REFERENCE = "getall";
const CREATE_CAMPAIGN_REFERENCE = "Add";
const UPDATE_CAMPAIGN_REFERENCE = "edit";
const DELETE_CAMPAIGN_REFERENCE = "delete";

export default {
  create(payload) {
    return Repository.post(transformRoute(CREATE_CAMPAIGN_BANNER), payload);
  },
  delete(payload) {
    return Repository.post(transformRoute(DELETE_CAMPAIGN_BANNER), payload);
  },
  getAll(payload) {
    return Repository.get(transformRoute(GET_ALL_CAMPAIGN_BANNER), {
      params: payload,
    });
  },
  edit(payload) {
    return Repository.post(transformRoute(EDIT_CAMPAIGN_BANNER), payload);
  },
  // for campaign master routes
  getMaster() {
    return Repository.post(transformRoute(GET_CAMPAIGN_MASTER));
  },
  addMaster(payload) {
    return Repository.post(transformRoute(ADD_CAMPAIGN_MASTER), payload);
  },
  updateMaster(payload) {
    return Repository.post(transformRoute(UPDATE_CAMPAIGN_MASTER), payload);
  },

  // for campaign partner routes
  get_partner(payload) {
    return Repository.get(transformRoute2(GET_PARTNER), {
      params: payload,
    });
  },
  add_partner(payload) {
    return Repository.post(transformRoute2(CREATE_PARTNER), payload);
  },
  update_partner(payload) {
    return Repository.post(transformRoute2(UPDATE_PARTNER), payload);
  },
  delete_partner(payload) {
    return Repository.post(transformRoute2(DELETE_PARTNER), payload);
  },

  //for campaign Home routes
  get_campaignhome(payload) {
    return Repository.get(transformRoute3(GET_CAMPAIGN_HOME), {
      params: payload,
    });
  },
  add_campaignhome(payload) {
    return Repository.post(transformRoute3(CREATE_CAMPAIGN_HOME), payload);
  },
  update_campaignhome(payload) {
    return Repository.post(transformRoute3(UPDATE_CAMPAIGN_HOME), payload);
  },
  delete_campaignhome(payload) {
    return Repository.post(transformRoute3(DELETE_CAMPAIGN_HOME), payload);
  },
  // for aboutcampaigns banner route

  get_aboutcampaignsbanner(payload) {
    return Repository.get(transformRoute4(GET_ABOUT_CAMPAIGN), {
      params: payload,
    });
  },
  add_aboutcampaignsbanner(payload) {
    return Repository.post(transformRoute4(CREATE_ABOUT_CAMPAIGN), payload);
  },
  update_aboutcampaignsbanner(payload) {
    return Repository.post(transformRoute4(UPDATE_ABOUT_CAMPAIGN), payload);
  },
  delete_aboutcampaignsbanner(payload) {
    return Repository.post(transformRoute4(DELETE_ABOUT_CAMPAIGN), payload);
  },
  /// Campaigns references
  get_campaignreference(payload) {
    return Repository.get(transformRoute5(GET_CAMPAIGN_REFERENCE), {
      params: payload,
    });
  },
  add_campaignreference(payload) {
    return Repository.post(transformRoute5(CREATE_CAMPAIGN_REFERENCE), payload);
  },
  update_campaignreference(payload) {
    return Repository.post(transformRoute5(UPDATE_CAMPAIGN_REFERENCE), payload);
  },
  delete_campaignreference(payload) {
    return Repository.post(transformRoute5(DELETE_CAMPAIGN_REFERENCE), payload);
  },
};

const transformRoute = (route) => {
  return `/campaign/main/${route}`;
};
const transformRoute2 = (route) => {
  return `/campaign/partner/${route}`;
};
const transformRoute3 = (route) => {
  return `/campaign/Home/${route}`;
};
const transformRoute4 = (route) => {
  return `/campaign/aboutcampaignbanner/${route}`;
};
const transformRoute5 = (route) => {
  return `/campaign/campaignreference/${route}`;
};
